import Link from 'next/link';
import InfoTooltip from 'src/components/InfoTooltip';

import MyTestButton from 'src/components/MyTestButton';
import { testUrl } from 'src/services/route-utils';

type Props = {
    className?: string;
    items: readonly any[];
};

export function AsideTests({ items, className }: Props) {
    return (
        <ul className={className}>
            {items.map((item) => (
                <li key={item.slug} className="border-light-green flex items-center border-t py-2 first:border-0">
                    <div className="text-primary flex-1">
                        <Link className="hover:underline" href={testUrl(item)}>
                            {item.name}
                        </Link>
                        <InfoTooltip title={item?.disclaimer} />
                    </div>
                    <MyTestButton test={item.slug} className="pl-4 text-3xl" />
                </li>
            ))}
        </ul>
    );
}
